<template>
  <div class="nhst-logos">
    <div class="container">
      <div class="row row--dense justify-content-between">
        <div class="col-sm-7 order-2 order-sm-1">
          <p v-if="!isFreeUserRegForm" v-html="$t('nhst.id.description')"></p>
        </div>
        <div class="col-sm-5 d-flex flex-row flex-sm-row-reverse nhst-logo order-1 order-sm-2 mb-4">
          <img
            :src="$cdn.resource('dn-media-group.svg')"
            class="align-self-center"
            alt="dn-media-group">
        </div>
      </div>
    </div>
    <p v-if="!isFreeUserRegForm"
      v-html="$t('nhst.id.popup.definition')"
      class="info-link mb-6"></p>
  </div>
</template>

<script>

import { nhstLogos } from '@mixins';

export default {
  name: 'nhst-logos',
  mixins: [nhstLogos]
};
</script>

<style scoped lang="scss">
@import "@assets/scss/variables.scss";

.row {
  margin: 0;
}

.nhst-logos {
  .info-link {
    text-align: left;
  }

  div {
    padding: 0;
  }

  font-size: 12px;
  line-height: 14.4px;
  text-align: left;
  font-weight: normal;

  p {
    padding: 0;
    margin-bottom: 12px;
    font-size: 12px;
    line-height: 18px;
  }
}
</style>
